export default {
    state: {
        message: "",
        type: "success",
        show: false
    },
    namespaced: true,
    mutations: {
        SET_MESSAGE: (state, {message, type}) => {
            state.message = message;
            if(type) {
                state.type = type;
            }
            state.show = message !== "";
        }
    },
    actions: {
        ALERT: ({commit}, {message, type}) => {
            commit('SET_MESSAGE', {message, type: type || 'success'});
        },
        ALERT_SUCCESS: ({commit}, message) => {
            commit('SET_MESSAGE', {message, type: 'success'});
        },
        ALERT_ERROR: ({commit}, message) => {
            commit('SET_MESSAGE', {message, type: 'error'});
        },
        ALERT_INFO: ({commit}, message) => {
            commit('SET_MESSAGE', {message, type: 'info'});
        },
        ALERT_WARNING: ({commit}, message) => {
            commit('SET_MESSAGE', {message, type: 'warning'});
        },
        ALERT_REMOVE: ({commit}, message) => {
            commit('SET_MESSAGE', {message: '', type: 'warning'});
        },
    }
};
